import React, { useState, useEffect } from 'react';
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import './Fairness.css'


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation, BsTransparency } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Fairness = () => {
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isDashModalOpen, setIsDashModalOpen] = useState(false);


    const goals = [
        {
            goal: 'Quality of service',
            PreGoal:'Goal F1:',
            description: 'AI systems are designed to provide a similar quality of service for identified demographic groups, including marginalized groups.',
            appliesTo: 'AI systems when system users or people impacted by the system with different demographic characteristics might experience differences in quality of service that the AI Systems developer(s) can remedy by building the system differently.',
            requirements: [
                {
                    id: 'F1.1',
                    text: 'Identify and prioritize demographic groups, including marginalized groups, that may be at risk of experiencing worse quality of service based on intended uses and geographic areas where the system will be deployed. Include:',
                    subRequirements: [
                        "groups defined by a single factor, and",
                        "groups defined by a combination of factors.",
                    ],
                    text2: 'Document the prioritized identified demographic groups using the Impact Assessment template.',
                    tags: ['Impact Assessment']
                },
                {
                    id: 'F1.2',
                    text: 'Evaluate all data sets to assess inclusiveness of identified demographic groups and collect data to close gaps. Document this process and its results.',
                    tags: null
                },
                {
                    id: 'F1.3',
                    text: 'Define and document the evaluation that you will perform to support this Goal. Include:',
                    subRequirements: [
                        "any system components to be evaluated, in addition to the whole system,",
                        "the metrics to be used to evaluate the system components and the whole system, and",
                        "a description of the data set to be used for this evaluation.",
                    ],
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F1.4',
                    text: 'Define and document Responsible Release Criteria to achieve this Goal, as follows: For each metric, document:',
                    subRequirements: [
                        "any target minimum performance level for all groups, and",
                        "the target maximum (absolute or relative) performance difference between groups.",
                    ],
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F1.5',
                    text: 'Evaluate the system according to the defined Responsible Release Criteria.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F1.6',
                    text: 'Identify and document any justifiable factors, such as circumstantial and other operational factors (e.g., “background noise” for speech recognition systems or “image resolution” for facial recognition systems), that account for:',
                    subRequirements: [
                        "any inability to meet any target minimum performance level for any identified demographic group, and",
                        "any remaining performance differences between identified demographic groups.",
                    ],
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F1.7',
                    text: 'Document the pre-release results from requirements F1.4, F1.5, and F1.6. Determine and document how often ongoing evaluation should be conducted to continue supporting this Goal.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F1.8',
                    text: 'Publish information for customers about:',
                    subRequirements: [
                        "identified demographic groups for which performance may not meet any target minimum performance level,",
                        "any remaining performance disparities between identified demographic groups that may exceed the target maximum, and",
                        "any justifiable factors that account for these performance levels and differences.",
                    ],
                    text2: 'When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags:['Transparency Note.']
                },
            ]
        },
        {
            goal: 'Allocation of resources and opportunities',
            PreGoal:'Goal F2:',
            description: 'AI systems that allocate resources or opportunities in essential domains are designed to do so in a manner that minimizes disparities in outcomes for identified demographic groups, including marginalized groups.',
            appliesTo: 'AI systems that generate outputs that directly affect the allocation of resources or opportunities relating to finance, education, employment, healthcare, housing, insurance, or social welfare.',
            requirements: [
                {
                    id: 'F2.1',
                    text: 'Identify and prioritize demographic groups, including marginalized groups, that may be at risk of being differentially impacted by the system based on intended uses and geographic areas where the system will be deployed. Include:',
                    subRequirements: [
                        "groups defined by a single factor, and",
                        "groups defined by a combination of factors.",
                    ],
                    text2: 'Document the prioritized identified demographic groups using the Impact Assessment template.',
                    tags: ['Impact Assessment']
                },
                {
                    id: 'F2.2',
                    text: 'Evaluate all data sets to assess inclusiveness of identified demographic groups and collect data to close any gaps. Document this process and its results.',
                },
                {
                    id: 'F2.3',
                    text: 'Define and document the evaluation that you will perform to support this Goal. Include:',
                    subRequirements: [
                        "any system components to be evaluated, in addition to the whole system,",	
                        "the metrics to be used to evaluate the system components and the whole system, and",
                        "the data set to be used for this evaluation.",
                    ],
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F2.4',
                    text: 'Define and document Responsible Release Criteria to achieve this Goal, as follows: For each metric, document the target maximum difference (absolute or relative) between the rates at which resources and opportunities are allocated to groups.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F2.5',
                    text: 'Evaluate the system according to the defined Responsible Release Criteria.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F2.6',
                    text: 'Reassess the system design, including the choice of training data, features, objective function, and training algorithm, to pursue the goal of minimizing differences between the rates at which resources and opportunities are allocated to identified demographic groups, paying particular attention to those that exceed the target maximum difference, while recognizing that doing so may appear to affect system performance and it is seldom clear how to make such trade-offs.',
                    text3: 'Consult with your legal representative to determine your approach to this, including how you will identify and document trade-offs.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F2.7',
                    text: 'Identify and document any justifiable factors that account for any remaining differences between the    rates at which resources and opportunities are allocated to identified demographic groups.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F2.8',
                    text: 'Document the pre-release results for the evaluation described by requirements F2.4, F2.5, and F2.6.Determine and document how often ongoing evaluation should be conducted to continue supporting this goal.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F2.9',
                    text: 'Publish information for customers about: any remaining differences between the rates at which resources and opportunities are allocated to identified demographic groups, and any justifiable factors that account for these differences. When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags: ['Transparency Note.']
                },
            ]
        },
        {
            goal: 'Minimization of stereotyping, demeaning, and erasing outputs',
            PreGoal:'Goal F3:',
            description: 'AI systems that describe, depict, or otherwise represent people, cultures, or society are designed to minimize the potential for stereotyping, demeaning, or erasing identified demographic groups, including marginalized groups.',
            appliesTo: 'AI systems when system outputs include descriptions, depictions, or other representations of people, cultures, or society.',
            requirements: [
                {
                    id: 'F3.1',
                    text: 'Identify and prioritize demographic groups, including marginalized groups, that may be at risk of being subject to stereotyping, demeaning, or erasing outputs of the system. Include:',
                    subRequirements: [
                        "groups defined by a single factor, and",
                        "groups defined by a combination of factors.",
                    ],
                    text2: 'Document the prioritized identified demographic groups using the Impact Assessment template.',
                    tags: ['Impact Assessment']
                },
                {
                    id: 'F3.2',
                    text: 'Define and document any system components to be evaluated, in addition to the whole system.',
                    tags: ['Impact Assessment.']
                },
                {
                    id: 'F3.3',
                    text: 'Define and document a plan to evaluate the system components and the whole system for risks of stereotyping, demeaning, and erasing the prioritized identified demographic groups. ',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F3.4',
                    text: 'Evaluate the system according to the plan defined in requirement F3.3.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F3.5',
                    text: 'Reassess the system design, including the choice of training data, features, objective function, and training algorithm, to pursue the goal of minimizing the potential for stereotyping, demeaning, and erasing the identified demographic groups.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F3.6',
                    text: 'Document the pre-release results from requirements F3.4 and F3.5. Determine and document how often ongoing evaluation should be conducted to continue supporting this goal. ',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'F3.7',
                    text: 'Publish information for customers about these risks involving identified demographic groups. When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
            ]
        },
    ];
 

  // Modal component
  const DashModal = ({ isOpen, onClose, selectedGroup }) => {
    if (!isOpen || !selectedGroup) return null;
  
    // Fetch the specific goal data based on `selectedGroup`
    const goalData = goals.find(goal => goal.goal === selectedGroup);
  
    if (!goalData) return null;
  
    return (
      <div className="dashModal">
        <div className="dashModalContent">
          <div className="dashModalBox">
            {/* Title Section */}
            <h2 className="goal-title">
              <span className="goal-prefix">{goalData.PreGoal}</span> <span className="Fair-goal-name">{goalData.goal}</span>
            </h2>
            <p className="applies-to">{goalData.description}</p>
            <p className="applies-to"><i>Applies to:</i> {goalData.appliesTo}</p> 
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="assessment-table">
                <thead>
                  <tr>
                    <th className="Fair-requirements-header">Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {goalData.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                      <td className="requirement-text">
                        <strong>{requirement.id}</strong> {requirement.text}
                        <br/>{requirement.text3}
                        {requirement.subRequirements && (
                            <ul className="sub-requirements-list">
                            {requirement.subRequirements.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                        {requirement.text2}
                        {requirement.subRequirements2 && (
                            <ul className="sub-requirements-list">
                            {requirement.subRequirements2.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                        {requirement.tags && requirement.tags.length > 0 && (
                            <p className="tags">
                            <strong>Tags:</strong> {requirement.tags.join(', ')}
                            </p>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
  
            {/* Close Button */}
            <button className="Fair-closeButton" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  };
  


  // Handle modal opening
  const openModal = (group) => {
    console.log(`Opening modal for: ${group}`);
    setSelectedGroup(group);
    setIsDashModalOpen(true);
  };

  const closeModal = () => {
    setIsDashModalOpen(false);
    setSelectedGroup(null);
  };

  


  return (
    <div style={{backgroundColor: 'rgb(240, 242, 245)', height: '100vh'}}>
      <div className='dashcontent'>
        <div>
          <h2>Fairness Goals</h2>
        </div>
        <div className="Fair-container">
          <div className="stats-box" onClick={() => openModal('Quality of service')}>
            <div className="icon-box black">
              <PiStrategyBold />
            </div>
            <div className="Fair-content-box">
              <br></br>
              <br></br>
              <h4>Goal F1:</h4>
              <h3>Quality of service</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        
          <div className="stats-box" onClick={() => openModal('Allocation of resources and opportunities')}>
            <div className="icon-box blue">
              <FaUniversalAccess />
            </div>
            <div className="Fair-content-box">
              <br></br>
              <br></br>
              <h4>Goal F2:</h4>
              <h3>Allocation of resources and opportunities</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>

          {/* Identifiability and Linkability */}
          <div className="stats-box" onClick={() => openModal('Minimization of stereotyping, demeaning, and erasing outputs')}>
            <div className="icon-box green">
              <PiIdentificationCardFill />
            </div>
            <div className="Fair-content-box">
              <br></br>
              <br></br>
              <h4>Goal F3:</h4>
              <h3>Minimization of stereotyping, demeaning, and erasing outputs</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        </div>
        {/* Modal for displaying the questions with recommendations */}
        <DashModal isOpen={isDashModalOpen} onClose={closeModal} selectedGroup={selectedGroup} />
      </div>
    </div>
  );
};

    

export default Fairness;